import React from 'react';
import { Link2 } from 'lucide-react';

export default function CRM() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <div className="flex items-center gap-3 mb-6">
        <Link2 size={28} className="text-[#064E3B]" />
        <h1 className="text-2xl font-bold text-stone-900" style={{ fontFamily: 'Playfair Display, serif' }}>
          CRM
        </h1>
      </div>
      <div className="bg-white border border-stone-200 rounded-xl p-8 text-center text-stone-500">
        <p className="text-lg font-medium mb-2">Integração com CRM</p>
        <p className="text-sm">Conecte seu CRM, importe leads por CSV ou utilize o InstaIMOB CRM integrado.</p>
      </div>
    </div>
  );
}
